export default __webpack_public_path__ + "static/media/Pankaj Jain.eb0ef75a.jpg";